import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { Language } from './interfaces/Language';

const DEFAULT_LANGUAGES: Language[] = ['en', 'es',  'cat'];

export const getAllLanguages = () => 
    window.config.LANGUAGES_AVAILABLE || DEFAULT_LANGUAGES;

i18n
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        fallbackLng: window.config.LANG,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        detection: {
            order: ['navigator', 'localStorage', 'querystring'], // Language detection order
            lookupLocalStorage: 'i18nextLng', // Look for language code in localStorage
            lookupQuerystring: 'lang', // Look for language in query string
            caches: ['localStorage'], // Cache detected languages in localStorage
        },
        supportedLngs: DEFAULT_LANGUAGES, // Use supportedLngs instead of whitelist        
    });

export default i18n;
